"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerSearchFilterTextContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
// import * as Colors from "../colors";
exports.ManagerSearchFilterTextContainer = styled_components_1.default.div `
  input {
    display: block;
    width: 100%;
  }
`;
//# sourceMappingURL=search-filter-text-container.js.map